module.exports = __webpack_public_path__ + "img/dynatrace-vector-logo.ab820c24.svg";